export default __webpack_public_path__ + "static/schology-feature-0cd9be2678bf3026538b8d398549f67f.webp";